<script>
import { GlSkeletonLoader } from '@gitlab/ui';
import { formatAgentFlowTitleWithId } from 'ee/ai/duo_agents_platform/utils';
import AgentStatusBadge from 'ee/ai/shared/widgets/agent_status_badge.vue';

export default {
  name: 'AgentFlowHeader',
  components: {
    GlSkeletonLoader,
    AgentStatusBadge,
  },
  props: {
    isLoading: {
      required: true,
      type: Boolean,
    },
    title: {
      required: true,
      type: String,
    },
    agentFlowDefinition: {
      required: true,
      type: String,
    },
    isSidePanelView: {
      type: Boolean,
      required: false,
      default: false,
    },
    status: {
      type: String,
      required: false,
      default: null,
    },
    humanStatus: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    pageTitle() {
      return formatAgentFlowTitleWithId(
        this.title,
        this.agentFlowDefinition,
        this.$route.params.id,
      );
    },
  },
};
</script>
<template>
  <div v-if="isLoading">
    <gl-skeleton-loader :lines="1" :width="400" />
  </div>
  <header
    v-else-if="isSidePanelView"
    class="gl-sticky gl-top-0 gl-z-9999 gl-shrink-0 gl-bg-default gl-p-0"
  >
    <div
      class="drawer-title gl-border-b gl-flex gl-items-center gl-justify-start gl-gap-4 gl-px-4 gl-pb-2 gl-pb-3 gl-pt-2"
    >
      <div class="gl-flex gl-grow gl-items-center gl-gap-3">
        <div class="gl-flex gl-flex-col gl-justify-center gl-gap-2">
          <h3
            class="gl-my-0 gl-line-clamp-1 gl-text-lg gl-text-default gl-break-anywhere"
            data-testid="agent-flow-side-panel-title"
          >
            {{ pageTitle }}
          </h3>
          <agent-status-badge v-if="status" :status="status" :human-status="humanStatus" />
        </div>
      </div>
      <div class="gl-flex gl-gap-3">
        <slot name="subheader"></slot>
      </div>
    </div>
  </header>
  <div v-else class="gl-flex gl-items-center gl-gap-2">
    <h1 class="gl-heading-1 gl-m-0" data-testid="agent-flow-page-title">{{ pageTitle }}</h1>
  </div>
</template>
